import React, { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import downloadIcon from "../../Asset/download.svg";

const DownloadButton = forwardRef(function DownloadButton({ view }, ref) {
  return (
    <div ref={ref}>
      <NavLink
        to="/download"
        className={`${
          view
            ? " anim-preserve scale-100 transition-transform duration-[600ms] ease-out opacity-100"
            : "opacity-0 scale-50"
        } bg-gradient-to-r from-[#3AB1F6]  to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out font-inter text-white lg:text-[18px] md:text-base text-sm w-max p-2 pr-5 flex items-center gap-2 rounded-full font-semibold`}
      >
        <span className="bg-white lg:p-2 p-1.5 rounded-full">
          <ReactSVG
            src={downloadIcon}
            beforeInjection={(svg) => {
              svg.setAttribute("class", "lg:w-5 w-4 lg:h-5 h-4");
            }}
          />
        </span>
        Download App
      </NavLink>
    </div>
  );
});

export default DownloadButton;
